import React from "react"
import { graphql } from "gatsby"

import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

import SectionHeadline from "../components/Sections/SectionHeadline"

export default ({ data }) => {
    const page = data.wordpressPage
    const { title, content } = page

    return (
        <>
            <SEO {...page} pageType="resources" />
            <div className="ehi-header--spacer"></div>
            <section className="bg-white">
                <SectionHeadline title={title}></SectionHeadline>
                <div
                    className="wysiwyg pb-xxl"
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </section>
        </>
    )
}

export const query = graphql`
    query($id: Int!) {
        wordpressPage(wordpress_id: { eq: $id }) {
            title
            excerpt
            content
            slug
            date
            modified
            author {
                name
            }
        }
    }
`
